import { Component } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-contact-us-wrapper',
  template: `
    <app-contact-us-v2 *ngIf="useRebranded"></app-contact-us-v2>
    <app-contact-us *ngIf="!useRebranded"></app-contact-us>
  `
})
export class ContactUsWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
